import { cn } from '#/lib/utils';
import { CheckCheck, Copy } from 'lucide-react';
import { ComponentProps, ReactNode, useCallback, useState } from 'react';
import ReactCopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'sonner';
import { Button } from '../ui/button';

type ButtonProps = ComponentProps<typeof Button>;

interface Props extends Omit<ButtonProps, 'onCopy'> {
  text?: string | null;
  children?: ReactNode;
}

export function CopyToClipboard({
  text,
  children,
  className,
  ...props
}: Props) {
  const onCopy = useCallback((text: string, result: boolean) => {
    if (result) {
      toast.success('Copied to clipboard');
    } else {
      toast.error('Copy failed');
    }
  }, []);

  return (
    // @ts-ignore
    <ReactCopyToClipboard.CopyToClipboard text={text ?? ''} onCopy={onCopy}>
      {children ?? (
        <Button
          variant="ghost"
          size="sm"
          className={cn('rounded-full w-9 px-0', className)}
          {...props}
        >
          <Copy className="w-3 h-3" />
        </Button>
      )}
    </ReactCopyToClipboard.CopyToClipboard>
  );
}

export function CopyToClipboardButton({
  text,
  children,
  className,
  ...props
}: Props) {
  const [result, setResult] = useState(false);
  return (
    <ReactCopyToClipboard.CopyToClipboard
      text={text ?? ''}
      onCopy={(text, result) => setResult(result)}
    >
      <Button type="button" {...props}>
        {result ? <CheckCheck /> : <Copy />}
        {children}
      </Button>
    </ReactCopyToClipboard.CopyToClipboard>
  );
}
